module.exports = __webpack_public_path__ + "img/bonore.2337f0c2.webp";